import { useQuery } from 'react-query';
import { getQueryKeys } from '../../../../shared/lib/getQueryKeys';
import request from '../../../../../../helpers/request';

const transportsQuery = async (companyId) => {
  return await request.get(
    `/TransportPermit/transport/list?companyId=${companyId}`,
    {},
    `При получении списка ТС произошла ошибка`
  );
};

export const useTransports = (companyId, options = {}) =>
  useQuery(
    getQueryKeys.transports(companyId),
    () => transportsQuery(companyId),
    options
  );
